<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/hotel']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png"> <span class="mx-4">Back</span>
  </button>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">

      <div class="row d-flex align-items-center flex-wrap">
        <div class="col-12 col-md-12 col-lg-6">
          <div class="d-flex align-items-start flex-column mb-3" *ngIf="ItemDetailHotel">
            <div class="mb-auto p-2 heading-1">{{ ItemDetailHotel.name }}</div>
            <div class="p-2">
              <div class="d-flex">
                <i class="ri-map-pin-line" style="color: var(--color-green-dark);"></i>
                <span class="title px-2">
                  {{ ItemDetailHotel.address }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <div class="row justify-content-end">
            <div class="col-12 col-md-12 col-lg-8 col-xl-7">
              <div class="dashboard-card" style="overflow: visible; position: relative;"
                (click)="openGalleryModal(galleryModal)">
                <i class="ri-arrow-right-up-line arrow-icon-gallery"></i>
                <div class="row">
                  <div
                    class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-sm-center">
                    <div class="hotel-image-container">
                      <ul class="photo-stack-grid">
                        <li>
                          <a>
                            <figure class="photo-stack">
                              <div [ngSwitch]="!!firstFilePath">
                                <img *ngSwitchCase="false" src="assets/images/Empty-State.png" alt="Empty building">
                                <img *ngSwitchDefault [src]="firstFilePath" alt="Picture">
                              </div>
                            </figure>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-12 col-md-7 col-lg-7 d-flex align-items-center justify-content-start">
                    <div class="stats-container">
                      <div class="section-title">Room Available</div>
                      <div class="stats-value">{{ ItemDetailHotel.available_rooms | thousandSeparator }}</div>
                      <i class="fa-solid fa-arrow-up-right arrow-icon"></i>

                      <div class="section-title mt-4">Room Sold</div>
                      <div class="stats-value">{{ ItemDetailHotel.occupied_rooms | thousandSeparator }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-4">
        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-revenue">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue.png"> Revenue
              </h5>

              <div *ngIf="!isLoading && revenueItem.length > 0">
  
                <!-- TOTAL SECTION (Modified) -->
                <div class="container-fluid container-box-progress mt-3" *ngFor="let item of totalRevenueOnly">
                  <div class="row">
                    <!-- Header dengan master toggle -->
                    <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <!-- Budget Section (selalu tampil) -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                    <div *ngIf="isTotalExpanded">
                      <!-- Last Month Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>

                      <!-- Last Year Section -->
                      <div class="metric-group">
                        <div class="remarks-text">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>

                      <!-- This Year Section -->
                      <div class="metric-group last-group">
                        <div class="remarks-text">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd| rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>
                
                <!-- Room Section (dengan icon) -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'Room'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>

                <!-- Horizontal Line Separator -->
                <hr class="my-3" style="border-top: 1px solid #dee2e6;">

                <!-- F&B Section -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'F&B'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- F&B Sub-items - Restaurant -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index" style="padding-left: 20px;">
                  <div *ngIf="item.name === 'F&B - Restaurant'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>
                    
                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>

                <!-- F&B Sub-items - MICE -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index" style="padding-left: 20px;">
                  <div *ngIf="item.name === 'F&B - Mice'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Horizontal Line Separator -->
                <hr class="my-3" style="border-top: 1px solid #dee2e6;">

                <!-- Other Section -->
                <div class="mb-3 revenue-item-card" *ngFor="let item of revenueItem; let i = index">
                  <div *ngIf="item.name === 'Other'">
                    <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                      <div class="col-5 title-text">
                        {{ item.name }}
                        <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                      </div>
                      <div class="col-7 total-text">{{ item.total | rupiah }}</div>
                    </div>

                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.remarks }}</div>
                      <div class="percentage-value-wrapper">
                        
                        <span class="percentage-text" [class]="getPercentageClass(item.percentage)">
                          {{ item.percentage }}%
                        </span>
                        <span class="value-text">{{ item.budget | rupiah }}</span>
                      </div>
                    </div>

                    <div *ngIf="expandedStates[i]">
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.lm_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          
                          <span class="percentage-text" [class]="getPercentageClass(item.lm_percentage)">
                            {{ item.lm_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_month | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ly_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          
                          <span class="percentage-text" [class]="getPercentageClass(item.ly_percentage)">
                            {{ item.ly_percentage }}%
                          </span>
                          <span class="value-text">{{ item.last_year | rupiah }}</span>
                        </div>
                      </div>
                      <div class="metric-group last-group">
                        <div class="remarks-text remarks-with-padding">{{ item.ty_remarks }}</div>
                        <div class="percentage-value-wrapper">
                          <span class="value-text">{{ item.total_ytd | rupiah }}</span>
                          <span class="percentage-text" [class]="getPercentageClass(item.ty_percentage)">
                            {{ item.ty_percentage }}%
                          </span>
                          <span class="value-text">{{ item.this_year | rupiah }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="d-flex justify-content-center" *ngIf="!isLoading && revenueItem.length === 0">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        
        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-2.png"> Occupancy
              </h5>
              <div class="container-fluid container-box-progress mt-3" *ngIf="ItemDetailHotelOccupancy">
                <div class="row">
                  <!-- Header dengan master toggle -->
                  <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ ItemDetailHotelOccupancy.name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                    </div>
                    <div class="col-7 total-text">{{ ItemDetailHotelOccupancy.total}}%</div>
                  </div>

                  <!-- Budget Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ ItemDetailHotelOccupancy.remarks }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelOccupancy.from_budget)">
                        {{ ItemDetailHotelOccupancy.from_budget }}%
                      </span>
                      <span class="value-text">{{ ItemDetailHotelOccupancy.budget }}%</span>
                    </div>
                  </div>
                  
                  <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                  <div *ngIf="isTotalExpanded">
                    <!-- Last Month Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemDetailHotelOccupancy.lm_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelOccupancy.pct_lm)">
                          {{ ItemDetailHotelOccupancy.pct_lm }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelOccupancy.last_month}}%</span>
                      </div>
                    </div>

                    <!-- Last Year Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemDetailHotelOccupancy.ly_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelOccupancy.pct_ly)">
                          {{ ItemDetailHotelOccupancy.pct_ly }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelOccupancy.last_year}}%</span>
                      </div>
                    </div>

                    <!-- This Year Section -->
                    <!--<div class="metric-group last-group">
                      <div class="remarks-text">{{ ItemDetailHotelOccupancy.ty_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelOccupancy.pct_ty)">
                          {{ ItemDetailHotelOccupancy.pct_ty }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelOccupancy.this_year}}%</span>
                      </div>
                    </div>-->
                  </div>  
                </div>
              </div>

              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingOccupancy" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading occupancy data...</span>
                        </div>
                      </div>
                      <apx-chart *ngIf="!isLoadingOccupancy" [series]="chartOptions.series" [chart]="chartOptions.chart"
                        [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
                        [yaxis]="chartOptions.yaxis" [xaxis]="chartOptions.xaxis" [legend]="chartOptions.legend"
                        [colors]="chartOptions.colors" [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/average.png"> Average Room Rate
              </h5>
              <div class="container-fluid container-box-progress mt-3" *ngIf="ItemDetailHotelAveragePrice">
                <div class="row">
                  <!-- Header dengan master toggle -->
                  <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ ItemDetailHotelAveragePrice.name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                    </div>
                    <div class="col-7 total-text">{{ ItemDetailHotelAveragePrice.total | rupiah }}</div>
                  </div>

                  <!-- Budget Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ ItemDetailHotelAveragePrice.remarks }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelAveragePrice.from_budget)">
                        {{ ItemDetailHotelAveragePrice.from_budget }}%
                      </span>
                      <span class="value-text">{{ ItemDetailHotelAveragePrice.budget | rupiah }}</span>
                    </div>
                  </div>
                  
                  <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                  <div *ngIf="isTotalExpanded">
                    <!-- Last Month Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemDetailHotelAveragePrice.lm_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelAveragePrice.pct_lm)">
                          {{ ItemDetailHotelAveragePrice.pct_lm }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelAveragePrice.last_month | rupiah }}</span>
                      </div>
                    </div>

                    <!-- Last Year Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemDetailHotelAveragePrice.ly_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelAveragePrice.pct_ly)">
                          {{ ItemDetailHotelAveragePrice.pct_ly }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelAveragePrice.last_year | rupiah }}</span>
                      </div>
                    </div>

                    <!-- This Year Section -->
                    <!--<div class="metric-group last-group">
                      <div class="remarks-text">{{ ItemDetailHotelAveragePrice.ty_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemDetailHotelAveragePrice.pct_ty)">
                          {{ ItemDetailHotelAveragePrice.pct_ty }}%
                        </span>
                        <span class="value-text">{{ ItemDetailHotelAveragePrice.this_year | rupiah }}</span>
                      </div>
                    </div>-->
                  </div>  
                </div>
              </div>
              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingAverageRoom" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading average room data...</span>
                        </div>
                      </div>
                      <apx-chart *ngIf="!isLoadingAverageRoom" [series]="chartOptionsAveragePrice.series"
                        [chart]="chartOptionsAveragePrice.chart" [dataLabels]="chartOptionsAveragePrice.dataLabels"
                        [plotOptions]="chartOptionsAveragePrice.plotOptions" [yaxis]="chartOptionsAveragePrice.yaxis"
                        [xaxis]="chartOptionsAveragePrice.xaxis" [legend]="chartOptionsAveragePrice.legend"
                        [colors]="chartOptionsAveragePrice.colors" [grid]="chartOptionsAveragePrice.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      
      <!-- Judul Utama -->
      <h1 class="heading-1 mb-4">Property Facilities & F&B Revenue</h1>
      
      <!-- Dua Kolom untuk Tabel Bersebelahan -->
      <div class="row">
        <!-- Kolom Kiri: Hotel Facility Information -->
        <div class="col-lg-6 mb-4">
          <div class="card h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0 fw-bold">Property Facilities Informations</h5>
            </div>
            <div class="card-body">
              <!-- Tabel Facility (Desktop) -->
              <div class="table-responsive d-none d-lg-block">
                <table class="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      <th class="text-center">Facility Name</th>
                      <th class="text-center">Total Unit</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="!isLoading && paginatedFacilities.length > 0">
                    <tr *ngFor="let item of paginatedFacilities">
                      <td class="text-left" 
                          [class.fw-bold]="!item.categoryName?.trim().startsWith('-')">
                        {{ item.categoryName }}
                      </td>
                      <td [class.text-center]="!item.categoryName?.trim().startsWith('-')"
                          [class.text-end]="item.categoryName?.trim().startsWith('-')"
                          [class.fw-bold]="!item.categoryName?.trim().startsWith('-')"
                          [class.pe-3]="item.categoryName?.trim().startsWith('-')">
                        {{ item.totalUnit }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="isLoading">
                    <tr>
                      <td colspan="2" class="text-center">
                        <div class="spinner-border text-success" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Tabel Facility (Mobile) -->
              <div class="d-block d-lg-none">
                <div class="container p-0">
                  <div class="row">
                    <div class="col-12" *ngFor="let item of paginatedFacilities; let i = index">
                      <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}">
                        <div class="card-body" *ngIf="!isLoading && paginatedFacilities.length > 0">
                          <div class="card-sm-header">
                            <h5>{{ item.categoryName }}</h5>
                          </div>
                          <div class="row">
                            <div class="col-5">
                              <div class="card-sm-title">Total Unit</div>
                            </div>
                            <div class="col-7">
                              <div class="card-sm-title">{{ item.totalUnit }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pagination untuk Facilities - PERBAIKAN: ganti facilitiesPageSize dengan facilitiesPaginationConfig.itemsPerPage -->
              <div class="row mt-4" *ngIf="facilitiesTotalItems > facilitiesPaginationConfig.itemsPerPage">
                <div class="col-12">
                  <div class="paging-wrapper">
                    <!-- Info Display -->
                    <div class="text-center text-muted small mb-2">
                      Displaying 
                      <span class="fw-bold">{{ facilitiesDisplayRange.start | number }}</span> - 
                      <span class="fw-bold">{{ facilitiesDisplayRange.end | number }}</span> 
                      out of 
                      <span class="fw-bold">{{ facilitiesDisplayRange.total | number }}</span>
                    </div>
                    
                    <!-- Pagination Controls -->
                    <div class="pagination-container d-flex justify-content-center">
                      <ul class="pagination mb-0">
                        <!-- First Page -->
                        <li class="page-item" [class.disabled]="facilitiesPaginationConfig.currentPage === 1">
                          <a class="page-link first-page" href="javascript:void(0)" (click)="onFacilitiesPageChange(1)" aria-label="First">
                            <span aria-hidden="true">««</span>
                          </a>
                        </li>
                        
                        <!-- Previous -->
                        <li class="page-item" [class.disabled]="facilitiesPaginationConfig.currentPage === 1">
                          <a class="page-link prev-page" href="javascript:void(0)" (click)="onFacilitiesPrevPage()" aria-label="Previous">
                            <span aria-hidden="true">«</span>
                          </a>
                        </li>
                        
                        <!-- Page Numbers (responsive) -->
                        <ng-container *ngFor="let page of facilitiesVisiblePages">
                          <li class="page-item" [class.active]="page === facilitiesPaginationConfig.currentPage" *ngIf="page !== -1">
                            <a class="page-link" href="javascript:void(0)" (click)="onFacilitiesPageChange(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item disabled" *ngIf="page === -1">
                            <span class="page-link">...</span>
                          </li>
                        </ng-container>
                        
                        <!-- Next -->
                        <li class="page-item" [class.disabled]="facilitiesPaginationConfig.currentPage === facilitiesTotalPages">
                          <a class="page-link next-page" href="javascript:void(0)" (click)="onFacilitiesNextPage()" aria-label="Next">
                            <span aria-hidden="true">»</span>
                          </a>
                        </li>
                        
                        <!-- Last Page -->
                        <li class="page-item" [class.disabled]="facilitiesPaginationConfig.currentPage === facilitiesTotalPages">
                          <a class="page-link last-page" href="javascript:void(0)" (click)="onFacilitiesPageChange(facilitiesTotalPages)" aria-label="Last">
                            <span aria-hidden="true">»»</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kolom Kanan: F&B Outlet Revenue -->
        <div class="col-lg-6 mb-4">
          <div class="card h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0 fw-bold">F&B Outlet Revenue</h5>
            </div>
            <div class="card-body">
              <!-- Tabel F&B Revenue (Desktop) -->
              <div class="table-responsive d-none d-lg-block">
                <table class="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      <th class="text-center">Outlet Name</th>
                      <th class="text-center">Revenue</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="!isLoading && paginatedFBOutlets.length > 0">
                    <tr *ngFor="let item of paginatedFBOutlets">
                      <td class="text-left">
                        {{ item.outletName }}
                      </td>
                      <td class="text-end pe-3">
                        <span [class.text-danger]="item.outletRevenue < 0">
                          {{ item.outletRevenue < 0 ? '(' + (item.outletRevenue * -1 | rupiah) + ')' : (item.outletRevenue | rupiah) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="isLoading">
                    <tr>
                      <td colspan="2" class="text-center">
                        <div class="spinner-border text-success" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Tabel F&B Revenue (Mobile) -->
              <div class="d-block d-lg-none">
                <div *ngIf="!isLoading && paginatedFBOutlets.length > 0">
                  <div *ngFor="let item of paginatedFBOutlets" class="card mb-2">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="fw-bold">{{ item.outletName }}</div>
                        <div [class.text-danger]="item.outletRevenue < 0">
                          {{ item.outletRevenue < 0 ? '(' + (item.outletRevenue * -1 | rupiah) + ')' : (item.outletRevenue | rupiah) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div *ngIf="isLoading" class="text-center p-3">
                  <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                
                <div *ngIf="!isLoading && paginatedFBOutlets.length === 0" class="text-center p-3">
                  No data available
                </div>
              </div>
              <!-- Pagination untuk F&B Outlets - PERBAIKAN: ganti fbOutletsPageSize dengan fbOutletsPaginationConfig.itemsPerPage -->
              <div class="row mt-4" *ngIf="fbOutletsTotalItems > fbOutletsPaginationConfig.itemsPerPage">
                <div class="col-12">
                  <div class="paging-wrapper">
                    <!-- Info Display -->
                    <div class="text-center text-muted small mb-2">
                      Displaying 
                      <span class="fw-bold">{{ fbOutletsDisplayRange.start | number }}</span> - 
                      <span class="fw-bold">{{ fbOutletsDisplayRange.end | number }}</span> 
                      out of 
                      <span class="fw-bold">{{ fbOutletsDisplayRange.total | number }}</span>
                    </div>
                    
                    <!-- Pagination Controls -->
                    <div class="pagination-container d-flex justify-content-center">
                      <ul class="pagination mb-0">
                        <!-- First Page -->
                        <li class="page-item" [class.disabled]="fbOutletsPaginationConfig.currentPage === 1">
                          <a class="page-link first-page" href="javascript:void(0)" (click)="onFBOutletsPageChange(1)" aria-label="First">
                            <span aria-hidden="true">««</span>
                          </a>
                        </li>
                        
                        <!-- Previous -->
                        <li class="page-item" [class.disabled]="fbOutletsPaginationConfig.currentPage === 1">
                          <a class="page-link prev-page" href="javascript:void(0)" (click)="onFBOutletsPrevPage()" aria-label="Previous">
                            <span aria-hidden="true">«</span>
                          </a>
                        </li>
                        
                        <!-- Page Numbers (responsive) -->
                        <ng-container *ngFor="let page of fbOutletsVisiblePages">
                          <li class="page-item" [class.active]="page === fbOutletsPaginationConfig.currentPage" *ngIf="page !== -1">
                            <a class="page-link" href="javascript:void(0)" (click)="onFBOutletsPageChange(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item disabled" *ngIf="page === -1">
                            <span class="page-link">...</span>
                          </li>
                        </ng-container>
                        
                        <!-- Next -->
                        <li class="page-item" [class.disabled]="fbOutletsPaginationConfig.currentPage === fbOutletsTotalPages">
                          <a class="page-link next-page" href="javascript:void(0)" (click)="onFBOutletsNextPage()" aria-label="Next">
                            <span aria-hidden="true">»</span>
                          </a>
                        </li>
                        
                        <!-- Last Page -->
                        <li class="page-item" [class.disabled]="fbOutletsPaginationConfig.currentPage === fbOutletsTotalPages">
                          <a class="page-link last-page" href="javascript:void(0)" (click)="onFBOutletsPageChange(fbOutletsTotalPages)" aria-label="Last">
                            <span aria-hidden="true">»»</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Fixed hotel-detail.component.html -->
<ng-template #galleryModal let-modal>
  <div class="hotel-gallery-container">
    <div class="row g-0">
      <!-- Left panel with filters -->
      <div class="col-12 col-md-12 col-lg-3 gallery-sidebar">
        <div class="p-3">
          <h4 class="mb-4">
            <i class="ri-door-open-line" style="color: var(--color-green-dark);"></i> Hotel Gallery
          </h4>

          <!-- Filter buttons container -->
          <div class="filters-container" *ngIf="categoryNames.length > 0">
            <button *ngFor="let category of categoryNames"
                    class="filter-btn"
                    [class.active]="currentFilter === category"
                    (click)="filterImages(category)">
              {{ category }}
            </button>
          </div>
        </div>
      </div>

      <!-- Right panel with image display -->
      <div class="col-12 col-md-12 col-lg-9 gallery-main">
        <!-- Close button -->
        <button type="button"
                class="btn-close gallery-close"
                aria-label="Close"
                (click)="modal.dismiss()">
        </button>

        <!-- Loading state -->
        <div class="loading-container" *ngIf="isLoading">
          <p>Loading images...</p>
        </div>

        <!-- Image container -->
        <div class="image-container" *ngIf="!isLoading && filteredImages && filteredImages.length > 0">
          <img [src]="currentImage.src"
               [alt]="currentImage.alt"
               (error)="onImageError($event)"
               (load)="onImageLoad($event)">

          <!-- Navigation buttons (only show if more than 1 image) -->
          <button class="nav-btn prev-btn"
                  (click)="prev()"
                  *ngIf="filteredImages.length > 1">
            <i class="ri-arrow-left-line"></i>
          </button>
          <button class="nav-btn next-btn"
                  (click)="next()"
                  *ngIf="filteredImages.length > 1">
            <i class="ri-arrow-right-line"></i>
          </button>

          <!-- Pagination info (only show if more than 1 image) -->
          <div class="pagination-info" *ngIf="filteredImages.length > 1">
            <span>{{ currentPage }} / {{ getTotalPages() }}</span>
          </div>
        </div>

        <!-- No images message -->
        <div class="no-images" *ngIf="!isLoading && (!filteredImages || filteredImages.length === 0)">
          <div class="text-center">
            <i class="ri-image-line" style="font-size: 48px; color: #ccc;"></i>
            <p>No images available for this category.</p>
          </div>
        </div>

        <!-- Error message -->
        <div class="error-message" *ngIf="error">
          <div class="text-center">
            <i class="ri-error-warning-line" style="font-size: 48px; color: #ff6b6b;"></i>
            <p>{{ error }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>